"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FeatureInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
      name = _ref.name,
      checked = _ref.checked,
      children = _ref.children,
      editable = _ref.editable,
      dataTestId = _ref.dataTestId,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["icon", "name", "checked", "children", "editable", "dataTestId", "onChange", "disabled", "className"]);

  var _useState = (0, _react.useState)(checked),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsChecked(checked);
  }, [checked]);

  var handleChange = function handleChange(e) {
    if (!disabled) {
      e.persist();
      setIsChecked(e.currentTarget.checked);
      onChange({
        name: e.target.name,
        value: e.currentTarget.checked
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(Feature, _extends({
    checked: isChecked,
    className: className,
    editable: editable
  }, otherProps), /*#__PURE__*/_react.default.createElement(Left, {
    checked: isChecked
  }, icon, /*#__PURE__*/_react.default.createElement("p", null, children)), editable ? /*#__PURE__*/_react.default.createElement(Right, null, /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    name: name,
    id: name,
    disabled: disabled,
    dataTestId: dataTestId,
    checked: isChecked,
    type: "checkbox",
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }), /*#__PURE__*/_react.default.createElement(StyledInput, {
    checked: isChecked,
    disabled: disabled
  }, isChecked ? /*#__PURE__*/_react.default.createElement(_Icons.IconStatusCheck, {
    size: 25
  }) : '')) : '');
});

var Feature = _styledComponents.default.label.withConfig({
  displayName: "Feature"
})(["display:flex;align-items:center;justify-content:flex-start;width:100%;max-width:100rem;background-color:", ";padding:0 2.6rem;min-height:75px;border-radius:2px;border:1px solid ", ";cursor:", ";p{font-family:", ";font-weight:400;font-size:1.4rem;line-height:120%;color:", ";flex:0 1 auto;}input[type='checkbox']{display:none;}"], function (_ref2) {
  var theme = _ref2.theme,
      checked = _ref2.checked;
  return checked ? theme.brand.lightest : '#fbfbfb';
}, function (_ref3) {
  var theme = _ref3.theme,
      checked = _ref3.checked;
  return checked ? theme.brand.light : '#c2c5cf';
}, function (_ref4) {
  var editable = _ref4.editable;
  return editable ? 'pointer' : 'default';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var theme = _ref6.theme,
      checked = _ref6.checked;
  return checked ? theme.brand.light : '#c2c5cf';
});

var StyledInput = _styledComponents.default.div.withConfig({
  displayName: "StyledInput"
})(["flex:0 0 25px;width:25px;height:25px;border-radius:2px;display:flex;justify-content:center;align-items:center;justify-self:end;background-color:", ";border:1px solid ", ";svg{margin-right:2px;path{fill:", ";}}"], function (_ref7) {
  var theme = _ref7.theme,
      disabled = _ref7.disabled;
  return disabled ? theme.ui.background : 'white';
}, function (_ref8) {
  var theme = _ref8.theme,
      checked = _ref8.checked,
      disabled = _ref8.disabled;
  return disabled ? theme.ui.disabled : checked ? theme.brand.light : '#c2c5cf';
}, function (_ref9) {
  var theme = _ref9.theme,
      checked = _ref9.checked,
      disabled = _ref9.disabled;
  return disabled ? theme.ui.disabled : checked ? theme.brand.light : '#c2c5cf';
});

var Left = _styledComponents.default.div.withConfig({
  displayName: "Left"
})(["flex:1 0 auto;display:flex;justify-content:flex-start;align-items:center;> svg{flex:0 0 35px;margin-right:2.5rem;path{fill:", ";}}"], function (_ref10) {
  var theme = _ref10.theme,
      checked = _ref10.checked;
  return checked ? theme.brand.light : '#c2c5cf';
});

var Right = _styledComponents.default.div.withConfig({
  displayName: "Right"
})([""]);

FeatureInput.displayName = 'FeatureInput';
FeatureInput.propTypes = {};
var _default = FeatureInput;
exports.default = _default;